import { Group, Text, rem } from "@mantine/core"
import { WebCalendarProfileDto } from "../../../../../@client/Theasoft_Shared_Contracts_WebCalendar"
import { CopyCalendarProfileLinkButton, MoreMenu } from "./more-menu"
import { SubscribeMenuButton } from "./subscribe-menu-button"
import { useIsSmallScreen } from "../../../../../utils/useIsSmallScreen"

interface Props {
  profile: WebCalendarProfileDto
  onEditProfileClick: (profile: WebCalendarProfileDto) => void
  isPrivateProfile: boolean
}

export function CalendarProfileStackItem({
  profile,
  onEditProfileClick,
  isPrivateProfile,
}: Props) {
  const isSmallScreen = useIsSmallScreen()
  return (
    <div
      style={{
        display: "grid",
        gap: rem(8),
        justifyItems: "start",
        alignItems: "start",
        gridTemplateColumns: "1fr auto auto",
      }}
    >
      <Text fw={700}>{profile.name}</Text>
      <Group>
        <SubscribeMenuButton profile={profile} />
        {!isSmallScreen ? (
          <CopyCalendarProfileLinkButton component="Button" profile={profile} />
        ) : null}
        <MoreMenu
          onEditProfileClick={onEditProfileClick}
          profile={profile}
          isPrivate={isPrivateProfile}
        />
      </Group>
      <p></p>
      <Text>{profile.description} </Text>
    </div>
  )
}
